import * as React from 'react';
import {FunctionComponent} from 'react';
import {Global} from '../model/global';
import {Heading, Table, TableBody, TableHeader, TableHeaderItem, TableItem, TableRow} from 'spectacle';
import {isPast, isSameMonth, format, differenceInMonths} from 'date-fns';
import {Slide} from '../components/slide';
import {formatEuro} from '../../support/format_money';

interface OwnProps {
    data: Global;
}

export const Financial: FunctionComponent<OwnProps> = ({data}) => {
    const now = new Date();
    return (
        <Slide>
            <Heading size={1} style={{textAlign: 'left'}} lineHeight={1} textColor="secondary">
                Financial update
            </Heading>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHeaderItem />
                        <TableHeaderItem>Expected turnover</TableHeaderItem>
                        <TableHeaderItem>Max expected turnover</TableHeaderItem>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {data.financial.map((month) => {
                        const date = new Date(month.date.date);
                        if (isPast(date) && !isSameMonth(date, now)) {
                            return (
                                <TableRow key={month.date.date}>
                                    <TableItem>{format(date, 'MMMM Y')}</TableItem>
                                    <TableItem>{formatEuro(month.turnover)}</TableItem>
                                    <TableItem />
                                </TableRow>
                            );
                        }

                        return (
                            <TableRow key={month.date.date} bgColor={isSameMonth(date, now) ? 'fourth' : undefined}>
                                <TableItem>{format(date, 'MMMM Y')}</TableItem>
                                <TableItem>{formatEuro(month.expectedTurnover)}</TableItem>
                                <TableItem textColor="tertiary">{formatEuro(month.maxExpectedTurnover)}</TableItem>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </Slide>
    );
};
